export default "__VITE_ASSET__C68itM7J__"